import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/$threadId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/operators/$threadId",
      params: { threadId: params.threadId },
      replace: true,
    });
  },
  component: () => null,
});
